import { Size } from './types';

const size = {
  [Size.xsmall]: 12,
  [Size.small]: 16,
  [Size.xmedium]: 20,
  [Size.medium]: 24,
  [Size.large]: 32,
  [Size.xlarge]: 40,
};

const getIconSize = (value: keyof typeof Size) => ({
  width: size[value],
  height: size[value],
});

export default getIconSize;
